import React from "react";
import classNames from "classnames";

type ButtonToggled = boolean;

type ToggleButton = JSX.IntrinsicElements["button"] & {
  active: ButtonToggled;
  toggle(): void;
};

function toggledToClassname(t: ButtonToggled): string {
  switch (t) {
    case true:
    return "Toggled";
    default:
    return "";
  }
}

const ToggleButton: React.FC<ToggleButton> = ({
  active,
  toggle,
  className,
  ...props
}) => {

  return (
    <button
      className={classNames(
        "ToggleBtn",
        "Btn",
        toggledToClassname(active),
        className
      )}
      onClick={ toggle }
      {...props}
    />
  )
};
  
export default ToggleButton;